import { render, staticRenderFns } from "./Drilldown.vue?vue&type=template&id=036e9725&scoped=true&"
import script from "./Drilldown.vue?vue&type=script&lang=js&"
export * from "./Drilldown.vue?vue&type=script&lang=js&"
import style0 from "./Drilldown.vue?vue&type=style&index=0&id=036e9725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e9725",
  null
  
)

export default component.exports